import moment from "moment";

const initialState = {
  campaign_no: 1000,
  currentStep: 1,
  steps: [
    {
      id: 1,
      title: "Input Product(s)",
      isVisible: true,
    },
    {
      id: 2,
      title: "Campaign Structure",
      isVisible: true,
    },
    {
      id: 3,
      title: "Add SB Profile",
      isVisible: false,
    },
    {
      id: 4,
      title: "Sponsored Brand Video",
      isVisible: false,
    },
    {
      id: 5,
      title: "Add Targets",
      isVisible: true,
    },
    {
      id: 6,
      title: "Done",
      isVisible: true,
    },
  ],
  step_1: [],
  step_2: {
    type_1: {
      name: "Sponsored Products - Keyword Targeting",
      isSelected: false,
      namePrefix: "SP-M-KT",
      structureType: "Single Product in each Adgroup",
      isSeparateAdgroups: true,
      brandkeywords: {
        isSelected: true,
        dailyBuget: "50",
        totalBuget: "",
      },
      nonBrandkeywords: {
        isSelected: true,
        dailyBuget: "50",
        totalBuget: "",
      },
      biddingStrategy: "Fixed bidding",
    },
    type_2: {
      name: "Sponsored Products - Auto Targeting",
      isSelected: false,
      namePrefix: "SP-A",
      structureType: "Single Product in each Adgroup",
      dailyBuget: "50",
      totalBuget: "",
      biddingStrategy: "Fixed bidding",
    },
    type_3: {
      name: "Sponsored Brand - Keyword Targeting",
      isSelected: false,
      namePrefix: "SB-M-KT",
      structureType: "All Products in one Adgroup",
      brandkeywords: {
        isSelected: true,
        dailyBuget: "50",
        totalBuget: "",
      },
      nonBrandkeywords: {
        isSelected: true,
        dailyBuget: "50",
        totalBuget: "",
      },
    },
    type_4: {
      name: "Sponsored Brand - Video - Keyword Targeting",
      isSelected: false,
      namePrefix: "SB-V-KT",
      structureType: "All Products in one Adgroup",
      brandkeywords: {
        isSelected: true,
        dailyBuget: "50",
        totalBuget: "",
      },
      nonBrandkeywords: {
        isSelected: true,
        dailyBuget: "50",
        totalBuget: "",
      },
    },
  },
  step_3: {
    selectedProductIds: [],
    profile: "",
    brand_name: "",
    headline_text: "",
    store_page_url: "",
    image: null,
  },
  step_4: {
    profile: "",
    media_name: "",
    media_file: null,
    caption_file: null,
  },
  step_5: {
    brandkeywords: {
      isBroad: true,
      isPhrase: true,
      isExact: true,
      keywords: "",
      sp_m_kt_bid: "0.3",
      sb_m_kt_bid: "1",
      sb_v_kt_bid: "0.8",
    },
    nonBrandkeywords: {
      isBroad: true,
      isPhrase: true,
      isExact: true,
      keywords: "",
      sp_m_kt_bid: "0.3",
      sb_m_kt_bid: "1",
      sb_v_kt_bid: "0.8",
    },
    sp_a_bid: "0.2",
    isSuggestedKeywords: false,
  },
};

const addWalmartCampaignReducer = (state = initialState, action) => {
  switch (action.type) {
    case "GO_TO_NEXT_STEP": {
      const currentStepIndex = state.steps.findIndex(
        (step) => step.id === state.currentStep
      );

      if (currentStepIndex !== -1) {
        for (let i = currentStepIndex + 1; i < state.steps.length; i++) {
          if (state.steps[i].isVisible) {
            return { ...state, currentStep: state.steps[i].id };
          }
        }
      }
      return state;
    }

    case "GO_TO_PREVIOUS_STEP": {
      const currentStepIndex = state.steps.findIndex(
        (step) => step.id === state.currentStep
      );

      if (currentStepIndex !== -1) {
        for (let i = currentStepIndex - 1; i >= 0; i--) {
          if (state.steps[i].isVisible) {
            return { ...state, currentStep: state.steps[i].id };
          }
        }
      }
      return state;
    }

    case "DISPLAY_STEP": {
      return {
        ...state,
        steps: state.steps.map((step) => ({
          ...step,
          isVisible:
            step.id === action.payload.id
              ? action.payload.isVisible
              : step.isVisible,
        })),
      };
    }

    case "SET_STEP":
      return {
        ...state,
        [action.payload.step]: action.payload.data,
      };

    case "UPDATE_STEP2_DATA": {
      const { type, key, value } = action.payload;
      return {
        ...state,
        step_2: {
          ...state.step_2,
          [type]: key
            ? {
                ...state.step_2[type],
                [key]: { ...state.step_2[type][key], ...value },
              }
            : { ...state.step_2[type], ...value },
        },
      };
    }

    case "RESET_ADD_CAMPAIGN_STATE": {
      return initialState;
    }

    default:
      return state;
  }
};

export default addWalmartCampaignReducer;
